import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'hu',
  months: [
    'január',
    'február',
    'március',
    'április',
    'május',
    'június',
    'július',
    'augusztus',
    'szeptember',
    'október',
    'november',
    'december',
  ],
  monthsShort: ['jan', 'feb', 'már', 'ápr', 'máj', 'jún', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
  weekdays: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
  weekdaysMin: ['V', 'H', 'K', 'Sze', 'Cs', 'P', 'Szo'],
  weekdaysShort: ['Va', 'Hé', 'Ke', 'Sze', 'Csü', 'Pé', 'Szo'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm',
    lts: 'h:mm:ss',
    L: 'YYYY. MM. DD.',
    LL: 'YYYY. MMMM D.',
    'LL-D': 'YYYY. MMMM',
    'LL-Y': 'MMMM D.',
    LLL: 'YYYY. MMMM D. HH:mm',
    'LLL-Y': 'MMMM D. HH:mm',
    LLLL: 'YYYY. MMMM D., dddd, HH:mm',
    'LLLL-Y': 'MMMM D., dddd, HH:mm',
    l: 'YYYY.M.D.',
    'l-Y': 'M.D.',
    ll: 'YYYY. MMM. D.',
    'll-Y': 'MMM. D.',
    lll: 'YYYY. MMM. D., h:mm',
    'lll-Y': 'MMM. D., h:mm',
    llll: 'YYYY. MMM. D., ddd., h:mm',
    'llll-Y': 'MMM. D., ddd., h:mm',
    'll-Y+w': 'MMM D., ddd',
    'LT+to': 'H:mm ([GMT]Z)',
    'LLL+to': 'YYYY. MMMM D. H:mm ([GMT]Z)',
  },
  past: {
    y: { one: '%s évvel ezelőtt', other: '%s évvel ezelőtt' },
    M: { one: '%s hónappal ezelőtt', other: '%s hónappal ezelőtt' },
    w: { one: '%s héttel ezelőtt', other: '%s héttel ezelőtt' },
    d: { one: '%s napja', other: '%s napja' },
    h: { one: '%s órával ezelőtt', other: '%s órával ezelőtt' },
    m: { one: '%s perccel ezelőtt', other: '%s perccel ezelőtt' },
    s: { one: '%s másodperccel ezelőtt', other: '%s másodperccel ezelőtt' },
  },
  future: {
    y: { one: '%s év múlva', other: '%s év múlva' },
    M: { one: '%s hónap múlva', other: '%s hónap múlva' },
    w: { one: '%s hét múlva', other: '%s hét múlva' },
    d: { one: '%s nap múlva', other: '%s nap múlva' },
    h: { one: '%s óra múlva', other: '%s óra múlva' },
    m: { one: '%s perc múlva', other: '%s perc múlva' },
    s: { one: '%s másodperc múlva', other: '%s másodperc múlva' },
  },
  abbr: {
    y: { one: '%s év', other: '%s év' },
    M: { one: '%s p', other: '%s p' },
    w: { one: '%s h', other: '%s h' },
    d: { one: '%s n', other: '%s n' },
    h: { one: '%s ó', other: '%s ó' },
    m: { one: '%s perc', other: '%s perc' },
    s: { one: '%s mp', other: '%s mp' },
  },
  justNow: 'Épp most',
  yesterday: 'Tegnap',
  today: 'Ma',
  tomorrow: 'Holnap',
  weekStart: 1,
};
const localeName: LocaleName = 'hu';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (): string => '',
};
